import { flatMap } from 'lodash';
import { queryGoodsStockService } from './services';

export const getOneTimeChargeList = (data: any) => {
  const chargeList = flatMap(data?.feeItems || [], (item) =>
    flatMap(item.orderOtcOffers || [], (offer) =>
      offer.orderOtcQryPrices
        ? offer.orderOtcQryPrices.map((price: any) => ({
            ...price,
            ...offer,
            ...item,
          }))
        : [],
    ),
  );
  return chargeList;
};

// 888:DigitalSolution,924:DMS,890:eCommerce Hub三个服务类型 在单产品切换套餐、买包时不采集安装信息
export const isNotNeedInstallServType = (selectedRows: any) =>
  ![888, 924, 890].includes(selectedRows?.[0]?.servType);

export const STOCK_THRESHOLD_ZERO = 0;
export const STOCK_THRESHOLD_HIGH = 5;
export const STOCK_THRESHOLD_LOW = 2;

// tm 买包实物数量展示
export const getStockStatusAndColor = (
  stockCount: number,
  formMessages: any,
) => {
  if (stockCount > 5) {
    return { status: formMessages('memberMgr.inStock') };
  } else if (
    stockCount >= STOCK_THRESHOLD_LOW &&
    stockCount <= STOCK_THRESHOLD_HIGH
  ) {
    return { status: formMessages('memberMgr.limitedStock') };
  } else if (stockCount <= STOCK_THRESHOLD_LOW) {
    return { status: formMessages('memberMgr.outStock') };
  }
};
// tm 买包实物数量样式
export const getStockClassName = (qty: number, styles: any) => {
  if (qty > STOCK_THRESHOLD_HIGH) {
    return styles.inStock;
  } else if (qty >= STOCK_THRESHOLD_LOW) {
    return styles.limitStock;
  } else if (qty >= STOCK_THRESHOLD_ZERO) {
    return styles.outStock;
  }
  return '';
};

export const getGoodStockList = async (offerData: any) => {
  let goodsStockOfferList: any[] = [];
  if (offerData?.length > 0) {
    // 判断当前数组里面有没有productSpecification.modelId返回，如果有，则返回包含这个属性的新数组包含offerId和modelId
    const newProductOfferData = offerData?.filter(
      (item: any) => item?.productSpecification?.id,
    );

    // 组装offerList入参 {offerId: '', modelId: ''}
    const offerList = newProductOfferData
      ?.map((item: any) => {
        const modelId = item?.productSpecification?.modelId;
        if (modelId) {
          return {
            offerId: item?.id,
            modelId: modelId,
          };
        }
        return null; // 如果 modelId 没有值，返回 null
      })
      .filter((item: any) => item !== null); // 过滤掉所有为 null 的项

    if (newProductOfferData?.length > 0) {
      const goodsOffers = await queryGoodsStockService({
        offerList,
        needQryModelId: '', // 独立订户不需要传
      });
      // 根据offerId寻找result和goodsOffers相同的数据，将goodsOffers数组中qty添加到result对应的offerId对象内
      goodsStockOfferList = offerData?.map((item: any) => {
        const temp: any = { ...item };
        const goodsOffer = goodsOffers?.offerList?.find(
          (goodsItem: any) => goodsItem?.offerId === item?.id,
        );

        // 兼容qty可以为0的场景
        if (goodsOffer?.qty || goodsOffer?.qty === 0) {
          temp.qty = goodsOffer?.qty;
        }
        return temp;
      });
    } else {
      goodsStockOfferList = offerData; //newProductOfferData不存在 ，则直接返回offerData数据
    }
    return goodsStockOfferList;
  }
};

// 处理change bundle offer下订单indepProAttrList的报文数据
export const transferIndepProAttrList = (
  attrs: any[],
  isNeedFilter?: boolean,
) => {
  if (!Array.isArray(attrs) || attrs.length === 0) return null;
  // 根据是否需要过滤，过滤掉 operType 为 'X' 的项，并映射需要的字段
  const newAttrs = isNeedFilter
    ? attrs.filter((ele) => ele?.operType !== 'X')
    : attrs;
  const filteredAttrs = newAttrs.map((attr: any) => ({
    attrCode: attr?.attrCode,
    attrId: attr?.attrId,
    attrValue: attr?.attrValue,
    operationType: attr?.operType,
  }));
  // 如果过滤后的结果为空数组，返回 null
  return filteredAttrs.length > 0 ? filteredAttrs : null;
};

const bundleComposeTypeMap: Record<string, number> = {
  New: 1,
  Exist: 2,
};

// change bundle member下订单Action字段映射关系
const bundleActionMap = new Map()
  .set(1, 'A') // join new
  .set(203, 'A') // join exist
  .set(204, 'D') // quit
  .set(46, 'T') // termination
  .set(329, 'C') // change offer
  .set(432, 'M'); // modify subscriber

// 1: join new 2: join exists
export const getBundleComposeType = (item: any): number | undefined => {
  return bundleComposeTypeMap[item?.joinType];
};

export const getAction = (item: any): number | undefined => {
  return bundleActionMap.get(item?.subsEventId);
};

// 根据配置项返回的servType字符串格式转换成对象格式
export const getAllBundleMemberServType = (allServType: string) => {
  return allServType?.split(',').reduce((acc: any, item: any) => {
    const [key, value] = item.split(':');
    acc[key] = value;
    return acc;
  }, {});
};
